import { ValidateUtils } from 'utils';
import ValidateInvoice from '../InvoiceInfoModal/validateForm';

const validateForm = (
  {
    customerName,
    customerPhone,
    customerEmail,
    customerShippingAddress,
    customerProvinceCode,
    customerDistrictCode,
    customerWardCode,
    totalWard,
    invoice,
  },
  onSetError,
  translateAlertAction,
) => {
  if (ValidateUtils.isEmpty(customerName)) {
    onSetError('name', true);
    throw new Error(translateAlertAction('message_not_input_name'));
  }

  if (ValidateUtils.isEmpty(customerPhone)) {
    onSetError('phone', true);
    throw new Error(translateAlertAction('message_not_input_phone'));
  }

  if (!ValidateUtils.validatePhone(customerPhone)) {
    onSetError('phone', true);
    throw new Error(translateAlertAction('message_correct_phone_number_format'));
  }

  if (!ValidateUtils.isEmpty(customerEmail) && !ValidateUtils.validateEmail(customerEmail)) {
    onSetError('email', true);
    throw new Error(translateAlertAction('message_invalid_email'));
  }
  if (ValidateUtils.isEmpty(customerShippingAddress)) {
    onSetError('address', true);
    throw new Error(translateAlertAction('message_not_input_address'));
  }

  if (customerProvinceCode === '0') {
    throw new Error(translateAlertAction('message_you_have_not_selected_province_City'));
  }

  if (customerDistrictCode === '0') {
    throw new Error(translateAlertAction('message_you_have_not_selected_the_district'));
  }

  if (customerWardCode === '0' && totalWard > 0) {
    throw new Error(translateAlertAction('message_you_have_not_selected_province_City'));
  }

  const { invoiceRequest } = invoice || {};
  // validate invoice
  if (invoice && invoiceRequest) {
    ValidateInvoice({ ...invoice, translateAlertAction });

    // if (ValidateUtils.isEmpty(customerEmail) || !ValidateUtils.validateEmail(customerEmail)) {
    //   onSetError('email', true);
    //   throw new Error('Xuất hoá đơn yêu cầu thông tin email.');
    // }
  }
};

export default validateForm;
